import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";
import MyDrawer from "../../../components/Admin/Drawer";
import { LanguageProvider } from "../../../components/LanguageContext";
import Language from "./Language";
import { useStyles, theme } from "../theme.js";

const LanguageAdminPage = (props) => {
  const classes = useStyles();

  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <Language></Language>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </LanguageProvider>
  );
};

export default LanguageAdminPage;
